// Breakpoint sizes
// These tokens roughly translate to the following sizes:
//     XS to S: Average Mobile size.
//     S to M: Portrait Tablet.
//     M to L: Landscape Tablet, or a Small Desktop.
//     L to XL: Standard Desktop size.
//     XL to XXL: Large desktop.

export const size = {
  xs: '0px',
  s: '320px',
  m: '764px',
  l: '1016px',
  xl: '1436px',
  xxl: '1920px',
};

export const screen = {
  xs: `(min-width: ${size.xs})`,
  s: `(min-width: ${size.s})`,
  m: `(min-width: ${size.m})`,
  l: `(min-width: ${size.l})`,
  xl: `(min-width: ${size.xl})`,
  xxl: `(min-width: ${size.xxl})`,
};
